const toastDanger = (message) => {
  return {
    message,
    type: 'is-danger',
    queue: false
  }
}
const toastInfo = (message = 'Успешно') => {
  return {
    message,
    type: 'is-info',
    queue: false
  }
}
export { toastDanger, toastInfo }
